export const blogData = [
    {
        id: 1,
        title: 'Do you think that choosing a different way is somehow necessary for our life?',
        description: 'In life everyone chooses a path where he or she should go and get this desired success or something that his or her mind wants. Choosing happens when a work or a doing can be done in lots of ways like good way or bad way.',
        date: 'May30, 2020',
        image: 'https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.dreamstime.com%2Fillustration%2Fdifferent-way.html&psig=AOvVaw1pQRgywgNvPrTUkx-moSmF&ust=1638367026439000&source=images&cd=vfe&ved=0CAsQjRxqFwoTCJj3s_iewPQCFQAAAAAdAAAAABAD',
        url: 'https://evilarif97.medium.com/do-you-think-that-choosing-a-different-way-is-somehow-necessary-for-our-life-78967b9c33eb'
    },
    {
        id: 2,
        title: 'How a good education mindset can help you to be a good professional?',
        description: 'In Life we all need a profession to lead our life. Without it we can not have something that will give our life a meaning. ',
        date: 'May13, 2020',
        image: 'https://brandongaille.com/wp-content/uploads/2019/07/51-Good-Education-Related-Company-Names.png',
        url: 'https://evilarif97.medium.com/how-a-good-education-mindset-can-help-you-to-be-a-good-professional-4b7c4d500820'
    },
    {
        id: 3,
        title: '5 reasons why eFootball PES 2021 is the best mobile Soccer game…',
        description: 'In this era of online gaming I can assure you that eFootball PES 2021 is the best and most exciting soccer game than any other soccer game in mobile platforms.',
        date: 'Aug 14, 2021',
        image: 'https://miro.medium.com/max/1400/1*4HHNZnZrDc1wysSZYuidQg.png',
        url: 'https://evilarif97.medium.com/5-reasons-why-efootball-pes-2021-is-the-best-mobile-soccer-game-6a883c4fca29'
    },
    {
        id: 4,
        title: '',
        description: 'Want to check your internet speed from the terminal? Here\'s the perfect way to the that.',
        date: 'Sep 17, 2020',
        image: 'https://1.bp.blogspot.com/-XTVMsZP3HaM/Xxpl394txlI/AAAAAAAABws/zovXWiuNGg4TzBwYYVFfJ1ixDb3JfVokgCNcBGAsYHQ/w400-h195/speedtest.png',
        url: ''
    },
    {
        id: 5,
        title: '',
        description: 'In case you haven\'t heard of this game, GTA stands for \'Grand Theft Auto\'. It is an open-world game published by Rockstar Games.',
        date: 'Oct 1, 2020',
        image: 'https://1.bp.blogspot.com/-jhdtUBIRD_s/XxLFKQuRz9I/AAAAAAAABsM/mClfbfDFKvsUwA7Wyi25Lzu3DEmL2lxrACNcBGAsYHQ/s1919/gta.jpg',
        url: ''
    },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/